//#region ENUM Ascii
/**
 * ### Ascii
 * Central catalogue of single–character glyphs (mostly Unicode, despite the
 * historical name) that the UI uses for icons, status marks, and indentation.
 *
 * Keeping them here prevents “magic characters” from being sprinkled
 * throughout the codebase and guarantees visual consistency.
 *
 * @enum Ascii
 * @example
 * // Render a small ✅/❌ next to a boolean value
 * const glyph = isOk ? Ascii.CheckMark : Ascii.CrossMark;
 */
export enum Ascii {
  ArrowRight = '→',
  DownRightArrow = '↪',
  EmptySpace = '\u00A0\u00A0\u00A0',
  SingleEmptySpace = '\u00A0',
  CheckMark = '✅',
  CrossMark = '❌',
  CircledI = 'ⓘ',
  Circled0 = '⓪',
  Circled1 = '①',
  Circled2 = '②',
  Circled3 = '③',
  Circled4 = '④',
  Circled5 = '⑤',
  Circled6 = '⑥',
  Circled7 = '⑦',
  Circled8 = '⑧',
  Circled9 = '⑨',
  Hourglass = '⏳',
}

//#endregion
